import React from 'react';

import { BarTask } from '@interfaces/ganttTasks/barTask';

import BarDisplay from '../BarDisplay';
import { getBarBorderColor, getBarColor } from './utils';

import styles from './Bar.module.scss';

interface IBarProps {
	task: BarTask;
}

const Bar = ({
	task,
}: IBarProps) => {
	const barColor = getBarColor(task);
	const barBorderColor = getBarBorderColor(task);

	return (
		<g
			className={styles.barWrapper}
			tabIndex={0}
		>
			<BarDisplay
				barBorderColor={barBorderColor}
				barColor={barColor}
				barCornerRadius={task.barCornerRadius}
				height={task.height}
				isFadeLeft={task.isWithoutStartDate}
				isFadeRight={task.isWithoutEndDate}
				width={task.x2 - task.x1}
				x={task.x1}
				y={task.y}
			/>
		</g>
	);
};

export default Bar;
